import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Invoices: Invoices_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
